import { ObfuscationDataType } from "~/gen/api/encrypt"

export interface ObfsRuleValidator { (x:string): boolean }
const anySatisfied = (a:ObfsRuleValidator, b:ObfsRuleValidator): ObfsRuleValidator => (x: string) => a(x) || b(x)
const allowEmpty = (x:string) => x === ''
const max500 = (x:string) => (x !== null && x !== undefined) && x.length <= 500

export const validators: Record<ObfuscationDataType, ObfsRuleValidator> = {
  [ObfuscationDataType.String]: anySatisfied(allowEmpty, max500),
  [ObfuscationDataType.DateTime]: anySatisfied(allowEmpty, (x) => {
    if (!max500(x)) { return false }
    try {
      const d = Date.parse(x)
      return !isNaN(d) &&
      /^\d{4}-\d{2}-\d{2}(\s\d{2}:\d{2}(:\d{2})?)?$/.test(x)
    } catch {
      return false
    }
  }),
  [ObfuscationDataType.Integer]: anySatisfied(allowEmpty, (x) => {
    if (x.replace(/[+-]/, '').length > 19) { return false }
    try {
      const n = Number.parseInt(x)
      return !isNaN(n) &&
        /^[+-]?\d+$/.test(x)
    } catch {
      return false
    }
  }),
  [ObfuscationDataType.Numeric]: anySatisfied(allowEmpty, (x) => {
    if (x.replace(/[+-.]/, '').length > 38) { return false }
    try {
      const n = Number.parseInt(x)
      return !isNaN(n) &&
        /^[+-]?\d*(\.?\d+)?$/.test(x) // do not support e notation
    } catch {
      return false
    }
  }),
}